import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useETEditorFormikPoolingType } from 'services/event_types';
import { useAvailabilitySidePanelActions } from '../context';
const footerContainerCss = "fohsov6";
const FooterContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} data-testid="event-type-editor-footer" className={classNames(footerContainerCss, props.className)} />;
});
export const Footer = ({
  onClose,
  formPath
}) => {
  const {
    openAvailabilitySidePanel
  } = useAvailabilitySidePanelActions();
  const {
    isMultiHost
  } = useETEditorFormikPoolingType();
  const [{
    value: availability
  }] = useFormField({
    name: formPath
  });
  const isMemberAvailability = Boolean(availability.userId || availability.organizationInvitationId);
  const showBackToPanelButton = isMultiHost && isMemberAvailability;
  const handleOpenPanel = () => openAvailabilitySidePanel({
    formPath,
    format: 'list'
  });
  return <FooterContainer data-component="calendar-view-footer">
      {showBackToPanelButton && <Button decoration="secondary-outline" onClick={handleOpenPanel}>
          {I18n.t('publisher.event_type_editor.sections.available_hours.date_overrides.back_to_panel')}
        </Button>}
      <Button type="button" onClick={onClose}>
        {I18n.t('publisher.action.close')}
      </Button>
    </FooterContainer>;
};

require("./footer.wyw-in-js.css!=!../../../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./footer.js");